// Structural data for the "Explore" tabs – which photos each area shows, in order.
// Text (kicker, title, lead, paragraphs, facts) comes from the per-language content files.
export const baseAreas = [
  { id: 'nanovitsa', photos: ['village-minaret', 'village-sign', 'village-view', 'village-road', 'village-signpost'] },
  { id: 'tatul', photos: ['tatul-panorama', 'tatul-sanctuary', 'tatul-niche', 'tatul-rock-niche', 'tatul-summit', 'tatul-excavation'] },
  { id: 'momchilgrad', photos: ['momchilgrad-square', 'momchilgrad-center'] },
  { id: 'kardzhali', photos: ['kardzhali-view', 'kardzhali-museum', 'kardzhali-reservoir'] },
]
